var utils = require('../../utils')

export default {
  name: 'report-history',
  data: function () {
    var today = new Date

    return {
      shopId: this.$store.getters.currentShopId,
      searchId: this.$route.params.id,
      searchType: this.$route.params.type,
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      deliveryDate: null,
      patientId: null,
      patientName: '',      // 患者名
      unsendHistory: false,  // 未送信履歴
      errorHistory: false,   // エラー履歴
      searchCallbackFlag: false,
      watchScroll: null,
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'm_patient.patient_name': {'state': false, 'order': false},
        't_report.delivery_date': {'state': true,  'order': false} // desc
      },
      sortStateInit: {},
      // 選択中の報告書送信ID
      selectedReportSendId: null
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.reportHistoriesSearchParams !== null) {
        this.$store.getters.reportHistoriesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.reportHistoriesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false
    var ssYear = window.sessionStorage.getItem('rhis-year')
    var ssMonth = window.sessionStorage.getItem('rhis-month')
    var ssDeliveryDate = window.sessionStorage.getItem('rhis-deliveryDate')
    var ssPatientName = window.sessionStorage.getItem('rhis-patientName')
    var ssSortKey = window.sessionStorage.getItem('rhis-sortKey')
    var ssSortStateOrder = window.sessionStorage.getItem('rhis-sortStateOrder')
    var ssUnsendHistory = window.sessionStorage.getItem('rhis-unsendHistory')
    var ssErrorHistory = window.sessionStorage.getItem('rhis-errorHistory')
    if (!!ssYear) {
      this.year = ssYear
    }
    if (!!ssMonth) {
      this.month = ssMonth
    }
    if (!!ssDeliveryDate) {
      this.deliveryDate = ssDeliveryDate
    }
    if (!!ssPatientName) {
      this.patientName = ssPatientName
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }
    if (!!ssUnsendHistory) {
      this.unsendHistory = Boolean(ssUnsendHistory)
    }
    if (!!ssErrorHistory) {
      this.errorHistory = Boolean(ssErrorHistory)
    }
    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }
    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }

    this.search(readMore)

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    years () {
      var today = new Date
      var years = []
      for (var y = 2015; y <= today.getFullYear(); y++ ) {
        years.push({'id': y, 'text': y + this.$t('ymd.year')})
      }
      return years
    },
    months () {
      var months = []
      for (var m = 1; m <= 12; m++ ) {
        months.push({'id': m, 'text': m + this.$t('ymd.month')});
      }
      return months
    },
    orderedReports () {
      return this.reportHistories
    },
    reportHistories () {
      return this.$store.getters.reportHistories
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.reportHistoriesNextPageNumber
    },
    totalCount () {
      return this.$store.getters.reportHistoriesTotalCount
    },
    currentPage () {
      return this.$store.getters.reportHistoriesCurrentPage
    },
    errorCount () {
      return this.$store.getters.reportHistoriesErrorCount
    },
    unsendCount () {
      return this.$store.getters.reportHistoriesUnsendCount
    },
    notify () {
      if (this.$store.getters.reportEditNotify !== null) {
        return this.$store.getters.reportEditNotify
      }
      return this.$store.getters.reportNotify
    }
  },
  methods: {
    /** 戻る */
    goPrev: function () {
      if (this.$route.params.type === 'facility') {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'facility_person') {
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'clinic') {
        this.$router.push({path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'care_office') {
        this.$router.push({path: '/care_offices', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },
    goSendBatchHistory: function () {
      this.$router.push({path: '/reports/batch_history/'+ this.searchType + '/' + this.searchId, query: {type: this.$router.currentRoute.query.type}})
    },
    goReportDetail: function(patientId, reportId) {
      this.$router.push({ path: '/reports/send/detail/' + this.$route.params.type + '/' + this.searchId + '/' + patientId + '/' + reportId, query: {type: this.$router.currentRoute.query.type}})
    },
    /** 報告書送信履歴検索 */
    search: function (readMore) {
      var url = null
      var clear = true
      var page = null
      var loadparams = 'true'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.reportHistoriesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.reportHistoriesSearchParams['scrollHeight']
        this.$store.getters.reportHistoriesSearchParams['pageYOffset'] = null
        this.$store.getters.reportHistoriesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        page = this.$store.getters.reportHistoriesNextPageNumber
        clear = false
        loadparams = 'block'
      } else {
        // 通常
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':          this.shopId,
        'search_id':        this.searchId,
        'search_id_type':   this.searchType,
        'year':             this.year,
        'month':            this.month,
        'delivery_date':    utils.wareki2Seireki(this.$t, this.deliveryDate),
        'patient_id':       this.patientId,
        'patient_name':     this.patientName,
        'error_flag':       this.errorHistory  ? "1" : "0",
        'unsend_flag':      this.unsendHistory ? "1" : "0",
        'page':             page,
        'ggDeliveryDate':   this.deliveryDate,
        'order':            this.orderByString()
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      window.sessionStorage.setItem('rhis-year', this.year)
      window.sessionStorage.setItem('rhis-month', this.month)
      if (!!this.deliveryDate) {
        window.sessionStorage.setItem('rhis-deliveryDate', this.deliveryDate)
      } else {
        window.sessionStorage.removeItem('rhis-deliveryDate')
      }
      if (!!this.patientName) {
        window.sessionStorage.setItem('rhis-patientName', this.patientName)
      } else {
        window.sessionStorage.removeItem('rhis-patientName')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("rhis-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("rhis-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("rhis-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("rhis-sortStateOrder")
      }
      if (!!this.unsendHistory) {
        window.sessionStorage.setItem('rhis-unsendHistory', this.unsendHistory)
      } else {
        window.sessionStorage.removeItem('rhis-unsendHistory')
      }
      if (!!this.errorHistory) {
        window.sessionStorage.setItem('rhis-errorHistory', this.errorHistory)
      } else {
        window.sessionStorage.removeItem('rhis-errorHistory')
      }

      this.$store.dispatch('REPORT_HISTORY_SEARCH', {url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
    },
    clearSearchParams: function () {
      if (this.$store.getters.canManage && this.shopId === null) {
        this.shopId = this.$store.getters.currentShopId
      }
      this.deliveryDate = null
      this.patientName = ''
      this.unsendHistory = false
      this.errorHistory = false
      this.$store.dispatch('REPORT_HISTORY_CLEAR', 0)
    },
    confirmPostSend: function (reportSendId) {
      var data = {
        'report_send_id': reportSendId,
        'change_status': 1
      }
      var self = this
      this.$store.dispatch('REPORT_HISTORY_SET_SEND_STATUS', {data: data, callback: function () {
        self.search('sort')
      }})
    },
    /** 未送信へ戻す ダイアログ 表示 */
    backPostSendModalShow: function (reportSendId) {
      this.selectedReportSendId = reportSendId
      this.$refs.backPostSendBtn.click() // モーダル表示 イベント発火
    },
    backPostSend: function () {
      var data = {
        'report_send_id': this.selectedReportSendId,
        'change_status': 0
      }
      var self = this
      this.$store.dispatch('REPORT_HISTORY_SET_SEND_STATUS', {data: data, callback: function () {
        self.search('sort')
      }})
    },
    checkUnsendHistory: function () {
      if (this.errorHistory) {
        this.errorHistory = false
      }
      this.search(false)
    },
    checkErrorHistory: function () {
      if (this.unsendHistory) {
        this.unsendHistory = false
      }
      this.search(false)
    },
    /** ソート */
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
          if (key === 'm_patient.patient_name') {
            result.push('t_report.delivery_date desc')
          }
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('t_report.delivery_date desc')
      }
      return result.join(' , ')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/report-history.js